import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/services/authentication.service';
import { Observable, throwError } from 'rxjs';
import { catchError, take, switchMap } from 'rxjs/operators';

export function authTokenInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthenticationService);

  const credentialsRequest = request.clone({ withCredentials: true });

  return authService.isUserAuthenticated().pipe(
    take(1),
    switchMap((isUserAuthenticated: boolean) => {
      return next(credentialsRequest).pipe(
        catchError((e: HttpErrorResponse) => {
          if (isUserAuthenticated && e.status === HttpStatusCode.Unauthorized) {
            authService.logout();
          }

          return throwError(() => e);
        })
      );
    })
  );
}
